// extracted by mini-css-extract-plugin
module.exports = {"Input":"TextEditor_Input__3z1P8","small":"TextEditor_small__1mudW","tiny":"TextEditor_tiny__3HSYe","mini":"TextEditor_mini__1XDug"};